<script>
import { Line,Bar } from "vue-chartjs";
import {
  getStyle,
  hexToRgba
} from "@coreui/coreui-pro/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";

export default {
  extends: Bar,
  props: ["height", "range", "session"],
  watch: {
    session: function(val) {
      this.onData()
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.onData()
     })
  },

  methods:{
    onData() {
      try{
        const gearColor = getStyle("--success") || "#4dbd74";
        const wattColor = getStyle("--info") || "#20a8d8";
        const hrColor = getStyle("--danger") || "#f86c6b";

      
        const _hr = this.session.data.map(a => a.hr);
        const _watt = this.session.data.map(a => a.pow);
        const _gear = this.session.data.map(a => {
          //const maxWatt = 500
          return a.gear
        });
        const _time= this.session.data.map(a =>{
          var t = a.t * 1000;
          var d = this.$moment.duration(t);
          var s = Math.floor(d.asHours()) + this.$moment.utc(t).format(":mm:ss");
      return s;
        } );
  
        ///const _labels = [];
        // const _date = this.$moment.utc(element.closedAt * 1000).format("DD-MM-YYYY");
        // _labels.push(_date);
      var ctx = document.getElementById("session-data").getContext("2d"); 
     
      var gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, 'rgba(0,255,78,0.2)');   
        gradient.addColorStop(1, 'rgba(0,255,252,0.2)');

        this.renderChart(
          {
            labels: _time,
            datasets: [
              {
                type: 'line',
                label: "HR",
                backgroundColor: hexToRgba(hrColor, 30),
                borderColor: hrColor,
                pointHoverBackgroundColor: "#fff",
                borderWidth: 1,
                data: _hr
              
              },
              {
                type: 'line',
                label: "WATTS",
                backgroundColor: hexToRgba(wattColor, 30),
                borderColor: wattColor,
                pointHoverBackgroundColor: "#fff",
                borderWidth: 1,
                data: _watt
              },
              {
                type: 'bar',
                label: "GEAR",
                yAxisID : "y-axis-2",
               	backgroundColor: gradient,
						    hoverBackgroundColor: gradient,
                // backgroundColor: hexToRgba(gearColor, 80),
                borderColor: gearColor,
                pointHoverBackgroundColor: "#fff",
                borderWidth: 1,
                data: _gear
              }
            ]
          },
          {
            tooltips: {
              enabled: false,
              custom: CustomTooltips,
              intersect: true,
              mode: "index",
              position: "nearest",
              callbacks: {
                labelColor: function(tooltipItem, chart) {
                  return {
                    backgroundColor:
                      chart.data.datasets[tooltipItem.datasetIndex].borderColor
                  };
                }
              }
            },
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              display: true,
                labels: {
                  fontColor: '#ffffff'
                }
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    drawOnChartArea: true
                  },
                  ticks: {
                    maxTicksLimit: 5,
                    fontColor: 'white'
            
                  },
                }
              ],
              yAxes: [
                {
                  id:"y-axis-1",
                  position:'left',
                  ticks: {
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    fontColor: 'white'
            
                  },
                  gridLines: {
                    display: false
                  }
                },
                {
                  id:"y-axis-2",
                  position:'right',
                  ticks: {
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    fontColor: 'white'
            
                  },
                  scaleLabel: {
                    display: true,
                    fontColor: 'white',
                    labelString: 'GEARS'
		              },
                  gridLines: {
                    display: true
                  }
                }
              ]
            },
            elements: {
              point: {
                radius: 0,
                hitRadius: 10,
                hoverRadius: 4,
                hoverBorderWidth: 3
              }
            }
          }
        );
    } catch(error){
      //console.log(error)
    }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/treadmill/SessionData.vue